<div class="consultation-summary-layout">
  <aside class="summary-left-pane">
    <div class="pane-header">
      <h3>Classifications</h3>
      <span class="item-count">{{ filteredSummaryItems.length }}</span>
    </div>

    <input class="classification-search" type="search" aria-label="Search classifications" placeholder="Search classifications" [value]="classificationSearch" (input)="classificationSearch = $any($event.target).value" />

    @if (isContextLoading) {
      <div class="pane-state">
        <mat-spinner diameter="28"></mat-spinner>
        <p>Loading Classifications...</p>
      </div>
    } @else if (filteredSummaryItems.length === 0) {
      <div class="pane-state empty">{{ classificationSearch ? 'No matching classifications found.' : 'No classifications found.' }}</div>
    } @else {
      <div class="source-list">
        @for (item of filteredSummaryItems; track trackBySummaryItem($index, item)) {
          <button type="button" class="source-item" (click)="selectClassification(item)" [class.selected]="selectedCondition === item.name" [attr.aria-pressed]="selectedCondition === item.name" [class.classification-item]="item.kind === 'classification'" [class.condition-item]="item.kind === 'condition'">
            <div class="source-item-row" [matTooltip]="getItemTooltip(item)" matTooltipPosition="above">
              <span class="source-item-main">{{ item.name }}</span>
              <div class="source-item-meta">
                @if (item.subText) {
                <span class="source-subtext">{{ item.subText }}</span>
                }
                <span class="source-status" [class.status-active]="item.status.toLowerCase() === 'active'" [class.status-inactive]="item.status.toLowerCase() === 'inactive'">{{ item.status | titlecase }}</span>
              </div>
            </div>
          </button>
        }
      </div>
    }
  </aside>

  <section class="summary-right-pane">
    <div class="pane-header">
      <h3>Patient Summary</h3>
    </div>

    @if (lastGeneratedAt) {
      <div class="generated-at">Generated: {{ lastGeneratedAt | date:'dd MMM yyyy, hh:mm a' }}</div>
    }

    @if (isSummaryLoading) {
      <div class="pane-state">
        <mat-spinner diameter="30"></mat-spinner>
        <p>Generating patient summary...</p>
      </div>
    } @else if (summaryError) {
      <div class="pane-state error">
        {{ summaryError }}
      </div>
    } @else if (!selectedCondition) {
      <div class="pane-state empty">Please select a classification from the left to get a summary.</div>
    } @else {
      <div class="summary-sections">
        @for (section of summarySections; track trackBySection($index, section)) {
          <article class="summary-section-card">
            @if (section.title !== 'Patient Summary') {
              <h4>{{ section.title }}</h4>
            }
            <div class="summary-content" [innerHTML]="section.html"></div>
          </article>
        }
      </div>
    }
  </section>
</div>
